import { render, staticRenderFns } from "./enableEditStand.vue?vue&type=template&id=8b1c124c"
import script from "./enableEditStand.vue?vue&type=script&lang=js"
export * from "./enableEditStand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports